
import React from 'react';
import {
  Dialog,
  DialogContent,
} from '@/components/ui/dialog';
import UserProfileForm from '@/components/users/UserProfileForm';
import { InviteUserDialog } from '@/components/users/InviteUserDialog';
import { DeleteUserDialog } from './DeleteUserDialog';
import { ResetPasswordDialog } from './ResetPasswordDialog';

interface UserDialogsProps {
  inviteDialogOpen: boolean;
  editingUser: {
    id: string;
    firstName: string;
    lastName: string;
  } | null;
  userToDelete: {
    id: string;
    email: string;
    name: string;
  } | null;
  userToResetPassword: {
    id: string;
    email: string;
    name: string;
  } | null;
  onInviteDialogClose: () => void;
  onEditDialogClose: () => void;
  onDeleteDialogClose: () => void;
  onResetPasswordDialogClose: () => void;
  onRefresh: () => void;
}

export const UserDialogs: React.FC<UserDialogsProps> = ({
  inviteDialogOpen,
  editingUser,
  userToDelete,
  userToResetPassword,
  onInviteDialogClose,
  onEditDialogClose,
  onDeleteDialogClose,
  onResetPasswordDialogClose,
  onRefresh
}) => {
  return (
    <>
      <InviteUserDialog 
        open={inviteDialogOpen} 
        onClose={onInviteDialogClose} 
        onInviteSent={onRefresh}
      />

      <Dialog open={!!editingUser} onOpenChange={onEditDialogClose}>
        <DialogContent>
          {editingUser && (
            <UserProfileForm
              profile={{
                id: editingUser.id,
                first_name: editingUser.firstName,
                last_name: editingUser.lastName,
                role: 'seller', // Default role, will be updated by the form
                created_at: new Date().toISOString(),
                updated_at: new Date().toISOString(),
                status: 'active'
              }}
              onClose={onEditDialogClose}
            />
          )}
        </DialogContent>
      </Dialog>

      <DeleteUserDialog
        userToDelete={userToDelete}
        onClose={onDeleteDialogClose}
        onRefresh={onRefresh}
      />
      
      <ResetPasswordDialog
        userToReset={userToResetPassword}
        onClose={onResetPasswordDialogClose}
        onReset={onRefresh}
      />
    </>
  );
};
